<app-rx-serie-2
  [patient]="data?.patient"
  [contact]="data?.contact"
  [series]="series"
  [dismissible]="true"
  (closed)="close()"></app-rx-serie-2>
